/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import React, { memo } from 'react';
import { SidebarBoundary } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/sidebar-boundary/index.tsx';
import { SidebarContent } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-common/src/ui/sidebar-content/index.tsx';
import { Skeleton } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-common/src/ui/skeleton/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazySidebarContent = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-sidebar-global-settings-issues-settings" */ './main.tsx'
		),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

const AsyncSidebar = (): React.JSX.Element => {
	return (
		<SidebarBoundary
			id="nav4.sidebar.global-settings.issues-settings"
			packageName="jiraNavigationAppsSidebarNav4GlobalSettingsIssuesSettings"
			ufoName="nav4.sidebar.global-settings.issues-settings"
		>
			<SidebarContent
				currentPageName="issues"
				// eslint-disable-next-line jira/integration/test-id-by-folder-structure
				testId="navigation-apps-sidebar-nav4-sidebars-settings-global-issues.ui.sidebar-content"
			>
				<Placeholder name="nav4.sidebar.global-settings.issues-settings" fallback={<Skeleton />}>
					<LazySidebarContent />
				</Placeholder>
			</SidebarContent>
		</SidebarBoundary>
	);
};

const ExportedComponent: React.MemoExoticComponent<() => React.JSX.Element> = memo(AsyncSidebar);
export default ExportedComponent;
